export const FAST_PAYMENT_DISCOUNT = 0.03 as const;
export const FAST_PAYMENT_MIN_DISCOUNT = 1500 as const; // amount in cents

export function applyFastPaymentDiscount(originalPrice: number): {
  priceWithDiscount: number;
  discount: number;
} {
  const priceInCents = Math.round(originalPrice * 100);
  const calculatedDiscount = Math.round(priceInCents * FAST_PAYMENT_DISCOUNT);
  const finalDiscount = Math.max(calculatedDiscount, FAST_PAYMENT_MIN_DISCOUNT);
  const resultInCents = priceInCents - finalDiscount;
  return {
    priceWithDiscount: resultInCents / 100,
    discount: calculatedDiscount / 100,
  };
}
